import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import FinanciadorEstudiosForm from '../FinanciadorEstudiosForm';

function FinanciadorEstudiosEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <FinanciadorEstudiosForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </FinanciadorEstudiosForm>
    </Edit>
  );
}

export default FinanciadorEstudiosEdit;
